import errorLogger from './errorLogger';
import pushInDataLayer from './pushInDataLayer';

interface ResponseRecaptchaBodyType {
  response: {
    name: string;
    event: {
      token: string;
      siteKey: string;
      userAgent: string;
      userIpAddress: string;
      expectedAction: string;
      hashedAccountId: string;
      express: boolean;
      requestedUri: string;
      wafTokenAssessment: boolean;
      ja3: string;
      headers: string[];
      firewallPolicyEvaluation: boolean;
    };
    riskAnalysis: {
      score: number;
      reasons: string[];
      extendedVerdictReasons: string[];
    };
    tokenProperties: {
      valid: boolean;
      invalidReason: string[];
      createTime: string;
      hostname: string;
      androidPackageName: string;
      iosBundleId: string;
      action: string;
    };
  };
  success: boolean;
  message: string;
}

const validateGoogleRecaptchaToken = async (token: string, expectedAction: string) => {
  const response = await fetch('/api/googleRecaptcha', {
    method: 'POST',
    body: JSON.stringify({
      event: {
        token,
        expectedAction,
        siteKey: process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY,
      },
    }),
    headers: {
      'content-type': `application/json`,
    },
  });

  const responseRecaptchaBody: ResponseRecaptchaBodyType = await response.json();

  if (!responseRecaptchaBody.success) {
    errorLogger(responseRecaptchaBody.message);
    return null;
  }

  return responseRecaptchaBody;
};

export const isTokenRecaptchaValid = async (token: string | null, expectedAction: string) => {
  const responseValidation = await validateGoogleRecaptchaToken(token ?? '', expectedAction);
  const isTokenRecaptchaValid = responseValidation?.response?.tokenProperties.valid;
  if (!isTokenRecaptchaValid) {
    pushInDataLayer({
      event: 'form-recaptcha-failed',
    });
  }
};

export default validateGoogleRecaptchaToken;
